class NewsletterForm extends HTMLElement {
  #mutationObserver;

  connectedCallback() {
    this.#mutationObserver = new MutationObserver(
      (mutationList, observer) => {

        const form = this.querySelector(".klaviyo-form-container form");
        if (!form) {
          return;
        }


        if (
          this.textContent
            .toLowerCase()
            .includes("thanks for subscribing")
        ) {
          this.#mutationObserver.disconnect();
          this.#mutationObserver = null;

          const successMessage = document.createElement("div");
          successMessage.className = "f0";
          successMessage.style.height = "63px";
          successMessage.style.lineHeight = "63px";
          successMessage.style.borderBottom = "1px solid rgba(255, 255, 255, 50%)";
          successMessage.textContent = "Thank you for subscribing!";
          this.append(successMessage);
        }
      }
    );
    this.#mutationObserver.observe(this, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }
  disconnectedCallback() {
    if (this.#mutationObserver) {
      this.#mutationObserver.disconnect();
      this.#mutationObserver = null;
    }
  }
}
if (!customElements.get("newsletter-form")) {
  customElements.define("newsletter-form", NewsletterForm);
}
